import { __spreadArrays } from "tslib";
var defaultOptionDescription = function (option, parentGroup, selected, selectedAriaLabel) {
    var messageParts = __spreadArrays([
        parentGroup && parentGroup.label,
        option.value,
        option.label,
        option.description,
        option.labelTag
    ], (option.tags || []), [
        selected ? selectedAriaLabel : null
    ]).filter(function (el) { return !!el; });
    return messageParts.join(' ');
};
export default defaultOptionDescription;
